import { Divider, Drawer } from 'antd';
import { Scrollbars } from 'react-custom-scrollbars-4';

import AdditionalLinks from '~/shared/components/header/components/additional-links';
import LanguageSwitcher from '~/shared/components/header/components/language-switcher';
import Menu from '~/shared/components/header/components/menu';
import MenuBar, { MenuList } from '~/shared/components/header/components/menu-bar/menu-bar';
import type { UserMenuItem } from '~/shared/configs/menus/get-user-menu-items-config';
import type { Locale } from '~/shared/constants';
import { getDeviceInfo } from '~/shared/helpers/get-device-info';
import type { ShortUserType } from '~/shared/types/user-type';

import './mobile-menu.scss';

type MobileMenuPropsType = Readonly<{
  onMobileMenuClose: () => void;
  isMainMenuToggled: boolean;
  lng: Locale;
  user: ShortUserType | null;
  menuItems: UserMenuItem[];
  isPlatform?: boolean;
  isAdminPanel?: boolean;
}>;

const MobileMenu = ({
  isPlatform = false,
  isAdminPanel = false,
  onMobileMenuClose,
  lng,
  user,
  isMainMenuToggled,
  menuItems,
}: MobileMenuPropsType) => {
  const device = getDeviceInfo();

  return (
    <Drawer
      placement="left"
      onClose={onMobileMenuClose}
      closable={false}
      open={isMainMenuToggled}
      className="mobile-menu"
      size={320}
    >
      <Scrollbars>
        <nav>
          <div className="mobile-menu__user-info">
            <MenuBar isNoPopup lng={lng} user={user} />
          </div>
          <div className="mobile-menu__user-name">
            {user?.firstName}&nbsp;{user?.lastName}
          </div>
          <Divider className="mobile-menu__divider" />
          <div className="mobile-menu__menu-bar">
            <MenuList menuItems={menuItems} closeMenu={onMobileMenuClose} />
          </div>
          <Divider className="mobile-menu__divider" />
          <div className="mobile-menu__menu">
            <Menu
              user={user}
              isPlatform={isPlatform}
              isAdminPanel={isAdminPanel}
              onMobileMenuClose={onMobileMenuClose}
              viewMode="vertical"
              withStudentsAttentionBadge={isPlatform}
              lng={lng}
            />
          </div>

          {!isPlatform && !isAdminPanel && <AdditionalLinks lng={lng} onMobileMenuClose={onMobileMenuClose} />}
          {device.isMobileDevice && (
            <div className="additional-menu__language-switcher">
              <LanguageSwitcher lng={lng} />
            </div>
          )}
        </nav>
      </Scrollbars>
    </Drawer>
  );
};

export default MobileMenu;
